export const en = {
    contact_me: 'I have questions, please contact me',
};
